import React from 'react';

export type RadioOption = {
  label: string;
  value: string;
  description?: string;
};

export type RadioGroupProps = {
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  options: RadioOption[];
  inline?: boolean;
  className?: string;
};

export function RadioGroup({
  name,
  value,
  onChange,
  options,
  inline = false,
  className
}: RadioGroupProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: inline ? 'row' : 'column',
        gap: '0.625rem'
      }}
    >
      {options.map((option) => (
        <label
          key={option.value}
          style={{
            display: 'flex',
            gap: '0.625rem',
            alignItems: 'flex-start',
            cursor: 'pointer'
          }}
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange?.(e.target.value)}
            style={{ marginTop: '0.125rem' }}
          />
          <span
            style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}
          >
            <span
              style={{
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: '1.5rem',
                color: 'var(--color-text-primary, #1a1a1a)'
              }}
            >
              {option.label}
            </span>
            {option.description && (
              <span
                style={{
                  fontSize: '0.875rem',
                  color: 'var(--color-text-secondary, #4b5563)'
                }}
              >
                {option.description}
              </span>
            )}
          </span>
        </label>
      ))}
    </div>
  );
}
